import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-white" }
const _hoisted_2 = { class: "pt-20" }

import Header from '../Header/Header.vue';
import Footer from '../Footer/Footer.vue';
import BackToTop from './BackToTop.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'AppLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(Footer),
    _createVNode(BackToTop)
  ]))
}
}

})